<template>

<div class="teamStats">
    <div class="stats-intro d-flex flex-wrap flex-md-nowrap">
        <div>
            <img src="" :data-src="teamLogo" class="lazyload teamLogo">
        </div>
        <div class="px-md-4 pt-3 pt-md-0" style="min-width: 300px">
            <div v-html="teamIntro">
            </div>

                <div class="introHeader">{{ teamStats.seasons.currentSeason.season.tournament.name.toUpperCase() }} {{ translations.wins_this_season }}</div>
                <div>{{ teamStats.seasons.teamStatistics[teamStats.seasons.currentSeason.id].standings.overall.split("-")[0] }}</div>
                <br />
                <div class="introHeader">{{ translations.manager }}</div>
                <div>{{ teamStats.manager.name }}</div>
                <br />
                <div class="introHeader">{{ translations.arena_stadium }}</div>
                <div>{{ teamStats.venue.name }}</div>
            
        </div>       
    </div>

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap">
        <div class="statsCard mr-md-3">
            <div class="selectDiv">
                <p class="stats-card-header">{{ translations.season }}</p>
                <select v-model="currentSeason" style="width: 100%; border-radius: 10px; padding: 8px 16px; border: 1px solid rgba(51, 51, 51, 0.25);">
                    <option v-for="(season) in teamStats.seasons.teamStatistics" :value="season.id">
                        20{{ season.season.seasonYear.split("/")[0] }}/20{{ season.season.seasonYear.split("/")[1] }}
                    </option>
                </select>
            </div>
        </div>
        <div class="statsCard">
            <div class="w-100">
               
                <p class="stats-card-header">{{ translations.played }}</p>
                <div class="d-flex justify-content-between">
                    <div class="stats-card-played-boxes"><p class="font-weight-bold text-center mb-1 played-header">{{ translations.total }}</p><p class="text-center mb-1" :key="gamesPlayed">{{ gamesPlayed }}</p></div>
                    <div class="stats-card-played-boxes"><p class="font-weight-bold text-center mb-1 played-header">{{ translations.wins }}</p><p class="text-center mb-1" :key="teamStats.seasons.teamStatistics[currentSeason].standings.overall.split('-')[0]">{{ teamStats.seasons.teamStatistics[currentSeason].standings.overall.split("-")[0] }}</p></div>
                    <div class="stats-card-played-boxes"><p class="font-weight-bold text-center mb-1 played-header">{{ translations.draws }}</p><p class="text-center mb-1" :key="teamStats.seasons.teamStatistics[currentSeason].standings.overall.split('-')[1]">{{ teamStats.seasons.teamStatistics[currentSeason].standings.overall.split("-")[1] }}</p></div>
                    <div class="stats-card-played-boxes"><p class="font-weight-bold text-center mb-1 played-header">{{ translations.loses }}</p><p class="text-center mb-1" :key="teamStats.seasons.teamStatistics[currentSeason].standings.overall.split('-')[2]">{{ teamStats.seasons.teamStatistics[currentSeason].standings.overall.split("-")[2] }}</p></div>
                </div>
           
            </div>
        </div>
        <div class="statsCardPlaceholder ml-md-3" :class="{ statsCard: teamStats.seasons.currentSeason.id == currentSeason }">
            <div v-if="teamStats.seasons.currentSeason.id == currentSeason">
                <p class="stats-card-header">{{ translations.form }}</p>
                <div class="d-flex justify-content-between">
                    <div>
                        <div class="stats-card-form-boxes" :class="teamStats.form[4]"><p class="m-0 text-center">{{ translations[teamStats.form[4]] }}</p></div>
                        <div class="stats-card-form-boxes-first" :class="teamStats.form[4]"></div>
                    </div>
                    <div class="stats-card-form-boxes align-self-start" :class="teamStats.form[3]"><p class="m-0 text-center">{{ translations[teamStats.form[3]] }}</p></div>
                    <div class="stats-card-form-boxes align-self-start" :class="teamStats.form[2]"><p class="m-0 text-center">{{ translations[teamStats.form[2]] }}</p></div>
                    <div class="stats-card-form-boxes align-self-start" :class="teamStats.form[1]"><p class="m-0 text-center">{{ translations[teamStats.form[1]] }}</p></div>
                    <div class="stats-card-form-boxes align-self-start" :class="teamStats.form[0]"><p class="m-0 text-center">{{ translations[teamStats.form[0]] }}</p></div>
                </div>
            </div>
        </div>
    </div>


    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap">
        <div class="statsCard mr-md-3">
            <p class="stats-card-header"><img data-src="https://objects.kaxmedia.com/auto/o/162304/14083d6f30.svg" class="stats-card-icon lazyload"><span class="ml-2">{{ translations.scored }}</span></p>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.total }}:</div>
                <div class="statsCardAttributeValue" :key="goalsScored">{{ goalsScored }}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.avg_per_game }}:</div>
                <div class="statsCardAttributeValue" :key="(goalsScored/gamesPlayed).toFixed(2)">{{ !gamesPlayed ? 0 : (goalsScored/gamesPlayed).toFixed(2) }}</div>
            </div>
        </div>
        <div class="statsCard">
            <p class="stats-card-header"><img data-src="https://objects.kaxmedia.com/auto/o/162306/87a7bbbd9e.svg" class="stats-card-icon lazyload"><span class="ml-2">{{ translations.conceded }}</span></p>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.total }}:</div> 
                <div class="statsCardAttributeValue" :key="goalsConceded">{{ goalsConceded }}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.avg_per_game }}:</div> 
                <div class="statsCardAttributeValue" :key="(goalsConceded/gamesPlayed).toFixed(2)">{{ !gamesPlayed ? 0 : (goalsConceded/gamesPlayed).toFixed(2) }}</div>
            </div>
        </div>
        <div class="statsCard ml-md-3">
            <p class="stats-card-header"><img data-src="https://objects.kaxmedia.com/auto/o/162307/3907f9225b.svg" class="stats-card-icon lazyload"><span class="ml-2">{{ translations.corners }}</span></p>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.total }}:</div>
                <div class="statsCardAttributeValue" :key="cornerKicks">{{ cornerKicks }}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.avg_per_game }}:</div>
                <div class="statsCardAttributeValue" :key="(cornerKicks/gamesPlayed).toFixed(2)">{{ !gamesPlayed ? 0 : (cornerKicks/gamesPlayed).toFixed(2) }}</div>
            </div>
        </div>
    </div>
    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap ">
        <div class="statsCard mr-md-3">
            <p class="stats-card-header"><img data-src="https://objects.kaxmedia.com/auto/o/162309/ace89dd93b.svg" class="stats-card-icon lazyload"><span class="ml-2">{{ translations.yellow_card }}</span></p>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.total }}:</div> 
                <div class="statsCardAttributeValue" :key="yellowCards">{{ yellowCards }}</div>
            </div>
            <div class="d-flex justify-content-between">
                <div class="statsCardAttributeHeader">{{ translations.avg_per_game }}:</div> 
                <div class="statsCardAttributeValue" :key="(yellowCards/gamesPlayed).toFixed(2)">{{ !gamesPlayed ? 0 : (yellowCards/gamesPlayed).toFixed(2) }}</div>
            </div>
        </div>
        <div class="statsCard">
                <p class="stats-card-header"><img data-src="https://objects.kaxmedia.com/auto/o/162308/cefccf9b39.svg" class="stats-card-icon lazyload"><span class="ml-2">{{ translations.red_card }}</span></p>
                <div class="d-flex justify-content-between">
                    <div class="statsCardAttributeHeader">{{ translations.total }}:</div>
                    <div class="statsCardAttributeValue" :key="redCards">{{ redCards }}</div>
                </div>
                <div class="d-flex justify-content-between">
                    <div class="statsCardAttributeHeader">{{ translations.avg_per_game }}:</div> 
                    <div class="statsCardAttributeValue" :key="(redCards/gamesPlayed).toFixed(2)">{{ !gamesPlayed ? 0 : (redCards/gamesPlayed).toFixed(2) }}</div>
                </div>
        </div>
        <div class="statsCard ml-md-3">
            <div class="w-100">            
                <p class="stats-card-header"><img data-src="https://objects.kaxmedia.com/auto/o/162305/914470f277.svg" class="stats-card-icon lazyload"><span class="ml-2">{{ translations.ball_possession }}</span></p>
                <div class="d-flex justify-content-between">
                    <div class="statsCardAttributeHeader">{{ translations.total }}:</div> 
                    <div class="statsCardAttributeValue" :key="ballPossession">{{ ballPossession }}%</div>
                </div>
                <p><progress class="possession-progress" :value="ballPossession" max="100"></progress></p>                
            </div>
        </div>
    </div>
</div>


</template>

<script>

export default {
    name: 'team-stats',
    props: {
        teamStats: {
            type: Object,
            required: true,
        }, 
        translations: {
            type: Object,
            required: true,
        },
        teamIntro: {
            type: String,
            required: false,
        },
        teamLogo: {
            type: String|Boolean,
            required: false,
        }
    },
    data: function () {
        return {
            currentSeason: this.teamStats.seasons.currentSeason.id,
            gamesPlayed: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].standings.gamesPlayed,
            yellowCards: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].yellow_cards.value,
            redCards: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].red_cards.value,
            ballPossession: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].average_ball_possession.value,
            cornerKicks: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].corner_kicks.value,
            goalsConceded: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].goals_conceded.value,
            goalsScored: this.teamStats.seasons.teamStatistics[this.teamStats.seasons.currentSeason.id].goals_scored.value,
        }
       
    },
    watch: {
        currentSeason() {
            this.gamesPlayed = this.teamStats.seasons.teamStatistics[this.currentSeason].standings.gamesPlayed;
            this.yellowCards = this.teamStats.seasons.teamStatistics[this.currentSeason].yellow_cards.value;
            this.redCards = this.teamStats.seasons.teamStatistics[this.currentSeason].red_cards.value;
            this.ballPossession = this.teamStats.seasons.teamStatistics[this.currentSeason].average_ball_possession.value;
            this.cornerKicks = this.teamStats.seasons.teamStatistics[this.currentSeason].corner_kicks.value;
            this.goalsConceded = this.teamStats.seasons.teamStatistics[this.currentSeason].goals_conceded.value;
            this.goalsScored = this.teamStats.seasons.teamStatistics[this.currentSeason].goals_scored.value;
        }
    },
    methods: {
        changeSession(event) {
            console.log(event)
        }
    },
    mounted: function () {
        if(!this.teamLogo) {
            this.teamLogo = this.teamStats.logo;
        }
    },
}

</script>